import { createSlice } from "@reduxjs/toolkit";
import { revertAll } from "../revertAll/RevertStateReducer";

const initialState = {
  list: [],
  listLoading: false,
  listError: null,

  addLoading: false,
  addError: null,

  editLoading: false,
  editError: null,

  deleteLoading: false,
  deleteError: null,

  unlockLoading: false,
  unlockError: null,

  resetPasswordLoading: false,
  resetPasswordError: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  extraReducers: (builder) => builder.addCase(revertAll, () => initialState),
  reducers: {
    fetchUsersStart(state) {
      state.listLoading = true;
      state.listError = null;
    },
    fetchUsersSuccess(state, action) {
      state.listLoading = false;
      state.list = action.payload;
    },
    fetchUsersFailure(state, action) {
      state.listLoading = false;
      state.listError = action.payload;
    },

    addUserStart(state) {
      state.addLoading = true;
      state.addError = null;
    },
    addUserSuccess(state) {
      state.addLoading = false;
    },
    addUserFailure(state, action) {
      state.addLoading = false;
      state.addError = action.payload;
    },

    editUserStart(state) {
      state.editLoading = true;
      state.editError = null;
    },
    editUserSuccess(state) {
      state.editLoading = false;
    },
    editUserFailure(state, action) {
      state.editLoading = false;
      state.editError = action.payload;
    },

    deleteUsersStart(state) {
      state.deleteLoading = true;
      state.deleteError = null;
    },
    deleteUsersSuccess(state) {
      state.deleteLoading = false;
    },
    deleteUsersFailure(state, action) {
      state.deleteLoading = false;
      state.deleteError = action.payload;
    },

    unlockUserStart(state) {
      state.unlockLoading = true;
      state.unlockError = null;
    },
    unlockUserSuccess(state) {
      state.unlockLoading = false;
    },
    unlockUserFailure(state, action) {
      state.unlockLoading = false;
      state.unlockError = action.payload;
    },

    resetPasswordEmailStart(state) {
      state.resetPasswordLoading = true;
      state.resetPasswordError = null;
    },
    resetPasswordEmailSuccess(state) {
      state.resetPasswordLoading = false;
    },
    resetPasswordEmailFailure(state, action) {
      state.resetPasswordLoading = false;
      state.resetPasswordError = action.payload;
    },
  },
});

export const {
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersFailure,
  addUserStart,
  addUserSuccess,
  addUserFailure,
  editUserStart,
  editUserSuccess,
  editUserFailure,
  deleteUsersStart,
  deleteUsersSuccess,
  deleteUsersFailure,
  unlockUserStart,
  unlockUserSuccess,
  unlockUserFailure,
  resetPasswordEmailStart,
  resetPasswordEmailSuccess,
  resetPasswordEmailFailure,
} = userSlice.actions;

export default userSlice.reducer;